import "./styles.css"
import { Outlet, Route, Routes } from "react-router-dom";
import Box from '@material-ui/core/Box';
import { Sidebar } from "pages/C001/Views/Sidebar/Sidebar";
import BookList from "pages/G001/View/Main"
import Ranking from "pages/G002/View/Main"
import Boys from "pages/Boys/View/Main"
import Girls from "pages/Girls/View/Main"
import Ladys from "pages/Ladys/View/Main"
import Fourcoma from "pages/4coma/View/Main"
import Magazine from "pages/Magazine/View/Main"
import Adult from "pages/Adult/View/Main"
import Photo from "pages/Photo/View/Main"
import AdultPhoto from "pages/AdultPhoto/View/Main"
import DmmBook from "pages/DmmBook/View/Main"
import Movie from "pages/Movie/View/Main"
import Search from "pages/Search/View/Main"
import Anime from "pages/Anime/View/Main"
import { Parent } from "pages/G003/Parent";
import { Child } from "pages/G003/Child";

import { useMedia } from 'use-media'

const Main = () => {
  const isWide = useMedia({ minWidth: "1000px" })
  console.log("isWide", isWide)
  return (
    <Box display="grid" gridAutoRows={"auto 1fr"}>
      <Sidebar />
      <Outlet />
    </Box>
  );
};

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Main />}>
        <Route path="/" element={<Boys />} />
        <Route path="/recommend" element={<Ranking />} />
        <Route path="/booklist" element={<BookList />} />
        <Route path="/boys" element={<Boys />} />
        <Route path="/girls" element={<Girls />} />
        <Route path="/ladys" element={<Ladys />} />
        <Route path="/4coma" element={<Fourcoma />} />
        <Route path="/magazine" element={<Magazine />} />
        <Route path="/adult" element={<Adult />} />
        <Route path="/photo" element={<Photo />} />
        <Route path="/adultphoto" element={<AdultPhoto />} />
        <Route path="/dmmbook" element={<DmmBook />} />
        <Route path="/movie" element={<Movie />} />
        <Route path="/search" element={<Search />} />
        <Route path="/anime" element={<Anime />} />
        <Route path="/parent" element={<Parent />} />
        <Route path="/child" element={<Child />} />
      </Route>
    </Routes>
  );
}
